<div class="simulation-form-shell">
  @if (loading) {
    <div class="simulation-loading" role="status" aria-live="polite">
      <fa-icon [icon]="spinnerIcon" animation="spin"></fa-icon>
    </div>
  } @else {
    <div class="simulation-content-grid">
      <ng-content select="[simulation-left]"></ng-content>
      <ng-content select="[simulation-right]"></ng-content>
    </div>
  }
</div>
